module.exports = __webpack_public_path__ + "static/img/plem17.3629f7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/plem17.png
// module id = mDdK
// module chunks = 1